export default __webpack_public_path__ + "static/media/5.38fb21a1.png";